import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { SpinnerService } from "../spinner/spinner.service";
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from "@angular/platform-browser";
/**
 * Choose Component
 */
let ChoosePayingComponent = class ChoosePayingComponent {
    constructor(httpClient, paymentService, router, route, auth, spinner, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.paymentService = paymentService;
        this.router = router;
        this.route = route;
        this.auth = auth;
        this.spinner = spinner;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.user = {};
        this.userType = '';
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.linkColor = '';
        this.borderRadiusSmaller = '';
        this.questionnaireSubmitted = true;
        this.spinner.start();
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        this.meansOfPayment = [];
        this.route.params.subscribe((params) => {
            this.nameOfCurrency = params['id'];
            this.user = JSON.parse(localStorage.getItem('user'));
            this.userType = this.user.user_type_id.type;
            this.status = this.userType + 'user';
            this.isIndividual = this.user.is_company_user ? 0 : 1;
            this.paymentService.getMeansOfPayment().subscribe(requestData => {
                this.meansOfPayment = JSON.parse(requestData['_body']);
                if (this.meansOfPayment.length === 1) {
                    this.router.navigateByUrl('/buy' + '/' + this.nameOfCurrency + '/' + this.meansOfPayment[0].verbose_id + '/buy');
                }
                else {
                    for (var i = 0; i < this.meansOfPayment.length; i++) {
                        this.meansOfPayment[i].disabled_mop = true;
                    }
                    this.httpClient.get('market/feesandlimits?is_individual=' + this.isIndividual).subscribe((data) => {
                        const feesForCurrency = data['buy'][this.nameOfCurrency];
                        if (feesForCurrency !== undefined) {
                            for (var i = 0; i < this.meansOfPayment.length; i++) {
                                if (this.meansOfPayment[i].verbose_id in feesForCurrency) {
                                    const activefees = feesForCurrency[this.meansOfPayment[i].verbose_id][this.userType];
                                    this.orderPaymentTime = parseInt(activefees.order_payment_time);
                                    this.fee = activefees.fee;
                                    this.meansOfPayment[i].fee = this.fee;
                                    this.meansOfPayment[i].disabled = activefees.disabled;
                                    this.meansOfPayment[i].disabled_mop = activefees.disabled_mop;
                                }
                            }
                        }
                    });
                }
            }, error => {
                console.log(error);
                this.spinner.stop();
            });
            this.spinner.stop();
        });
    }
    ngOnInit() {
        let scrollStep = -window.scrollY / (300 / 15);
        let scrollInterval = setInterval(function () {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
    }
    clickMeans(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!item.disabled && !item.disabled_mop) {
                if (this.user && this.user['risk_level'] === 'High') {
                    let data = yield this.httpClient.get('market/order/questionnaireFilled?risk_level=' + this.user['risk_level']).toPromise();
                    if (!data['isQuestionnaireFilled']) {
                        localStorage.setItem('riskLevel', this.user['risk_level']);
                        localStorage.setItem("questionnaireSubmitted", "false");
                        this.questionnaireSubmitted = false;
                        this.router.navigate(['/questionnaire'], { state: { currency: this.nameOfCurrency, meanOfPayment: item.verbose_id } });
                    }
                }
                if (this.questionnaireSubmitted) {
                    this.spinner.start();
                    this.router.navigateByUrl('/buy' + '/' + this.nameOfCurrency + '/' + item.verbose_id + '/buy');
                }
            }
        });
    }
    clickFaq() {
        this.router.navigateByUrl('/faq');
    }
};
ChoosePayingComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: PaymentService },
    { type: Router },
    { type: ActivatedRoute },
    { type: AuthService },
    { type: SpinnerService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ChoosePayingComponent = __decorate([
    Component({
        selector: 'ecd-choose-paying-component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./choose-paying.component.html")).default
    })
], ChoosePayingComponent);
export { ChoosePayingComponent };
